const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const baseURL = isLocal
  ? 'http://127.0.0.1:8000'
  : 'https://teanimo-be78b903b5e1.herokuapp.com'; 
